import { PaginatedApiResponseType } from "../types/common";
import { RecipientType } from "../types/message";
import { WalletType } from "../types/user";

export const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
export const IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL;
export const PROJECT_ID = process.env.REACT_APP_PROJECT_ID ?? "";
export const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL ?? "";
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM ?? "";
export const KEYCLOAK_CLIENT_ID =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "";
export const BASIC_KYC_LEVEL = process.env.REACT_APP_BASIC_KYC_LEVEL;
export const BASIC_KYB_LEVEL = process.env.REACT_APP_BASIC_KYB_LEVEL;
export const BASIC_KYT_LEVEL = process.env.REACT_APP_BASIC_KYT_LEVEL;
export const N_WALLET_ADDRESS = process.env.REACT_APP_N_WALLET_ADDRESS ?? "";
export const CUSTOMER_CARE_EMAIL = process.env.CUSTOMER_CARE_EMAIL;
export const messagesData: any[] = [
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
  {
    _id: 1,
    sender: "Sender",
    subject: "Subject",
    message: "Message",
    date: "Aug 15, 2:30 pm",
  },
];

export const recipientsData: RecipientType[] = [
  {
    id: "1",
    username: "Radha",
    email: "radha@gmail.com",
  },
  {
    id: "2",
    username: "Rahul",
    email: "shiviagnihotri@gmail.com",
  },
  {
    id: "3",
    username: "Rajesh",
    email: "rajesh@gmail.com",
  },
  {
    id: "4",
    username: "Faizan",
    email: "faizan@gmail.com",
  },
  {
    id: "5",
    username: "Rakesh",
    email: "rakesh@gmail.com",
  },
  {
    id: "6",
    username: "Amit",
    email: "amit@gmail.com",
  },
  {
    id: "7",
    username: "Sumit",
    email: "sumit@gmail.com",
  },
];

export const walletData: PaginatedApiResponseType<WalletType[]> = {
  count: 3,
  data: [
    {
      _id: "1",
      walletId: "OxWalletAddress1",
      walletAddress: "OxWalletAddress1",
      chain: "ETH",
      addedAt: "31 Dec 2023",
    },
    {
      _id: "2",
      walletId: "OxWalletAddress2",
      walletAddress: "OxWalletAddress2",
      chain: "Polkadot",
      addedAt: "02 Jan 2024",
    },
  ],
};
